import { render, staticRenderFns } from "./PortfolioGridLayoutPage.vue?vue&type=template&id=283c7fbb&"
import script from "./PortfolioGridLayoutPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioGridLayoutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports